import React, { useContext, useMemo, useState, useEffect } from "react";
import {
  Avatar,
  Badge,
  Button,
  Col,
  Dropdown,
  Flex,
  Image,
  Row,
  Skeleton,
  Space,
  Typography,
} from "antd";
import { Link } from "react-router-dom";

import logo from "../assets/karbonvise-logo.svg";
import { AuthContext } from "../providers/AuthProvider";
import { capitalize } from "lodash";
import { BellOutlined } from "@ant-design/icons";
import { useGetNotificationsQuery } from "../redux/services/tasks";
import NotificationDrawer from "./NotificationDrawer";
import { useGetMeQuery } from "../redux/services/users";
import { useGetConstantsQuery } from "../redux/services/constants";
import { IoLogOutOutline, IoLockOpenOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

const TopBar = ({ logoUrl }) => {
  const { handleLogout } = useContext(AuthContext);
  const { data: loggedInUser } = useGetMeQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const [open, setOpen] = useState(false);
  const data = {};
  const navigate = useNavigate();

  const orgName =
    loggedInUser?.email?.split("@")[1]?.split(".")[0] || "No Name";

  const items = [
    {
      key: "",
      label: `${loggedInUser?.email}`,
      disabled: true,
    },
    {
      key: "1",
      label: `Org : ${orgName}`,
      disabled: true,
    },
    {
      key: "2",
      label: `Role : ${loggedInUser?.role_name} `,
      disabled: true,
    },
    { type: "divider" },
    {
      key: "3",
      label: (
        <Button
          block
          type="ghost"
          onClick={() => navigate("/information/update-password")}
        >
          Update Password
        </Button>
      ),
      icon: <IoLockOpenOutline size={15} />,
    },
    { type: "divider" },
    {
      key: "4",
      label: (
        <Button block type="ghost" onClick={handleLogout}>
          Logout
        </Button>
      ),
      icon: <IoLogOutOutline size={15} />,
    },
  ];

  const hasUnreadNotification =
    data?.results?.filter((item) => item?.read_at === null)?.length > 0;

  const { data: appLogo, isLoading } = useGetConstantsQuery({
    key: "APP_LOGO",
  });

  const appLogoUrl = useMemo(
    () =>
      appLogo?.[0]?.value
        ? `${process.env.REACT_APP_API_HOST}/media/${appLogo?.[0]?.value}`
        : logo,
    [appLogo]
  );

  return (
    <Row justify={"center"} align={"middle"} style={{ height: "100%" }}>
      <Col span={22}>
        <Row
          align={"stretch"}
          justify={"space-between"}
          style={{ height: "100%" }}
        >
          <Flex align="center">
            <Skeleton
              style={{ width: 200 }}
              paragraph={{ rows: 0 }}
              loading={isLoading}
              active
            >
              <Link to={"/"}>
                <Image
                  src={isLoading ? "" : appLogoUrl}
                  preview={false}
                  height={40}
                  style={{ objectFit: "contain", objectPosition: "start" }}
                  width={200}
                />
              </Link>
            </Skeleton>
          </Flex>
          <Space size={"middle"} align="center" direction="horizontal">
            <Button
              type="ghost"
              onClick={() => setOpen(true)}
              icon={
                <Badge dot={hasUnreadNotification}>
                  <BellOutlined size={"100px"} onClick={() => setOpen(true)} />
                </Badge>
              }
            />
            <Dropdown
              menu={{
                items,
              }}
              placement="bottom"
            >
              <Space
                size={"middle"}
                direction="horizontal"
                style={{ alignItems: "center" }}
              >
                <Avatar
                  style={{
                    backgroundColor: "#00984A",
                    verticalAlign: "middle",
                  }}
                  size="default"
                >
                  {capitalize(
                    loggedInUser?.full_name?.charAt(0) ||
                      loggedInUser?.email?.charAt(0)
                  )}
                </Avatar>
                <Space.Compact
                  size={"small"}
                  direction="vertical"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Typography.Title level={5} style={{ marginBottom: 0 }}>
                    {loggedInUser?.first_name}
                  </Typography.Title>
                </Space.Compact>
              </Space>
            </Dropdown>
          </Space>
        </Row>
      </Col>
      <NotificationDrawer
        open={open}
        setOpen={setOpen}
        notifications={data?.results}
      />
    </Row>
  );
};

export default TopBar;
